/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Agenda_Source_Mirror_BodyInputs */



/**
* | output |
* | --- |
* | "Everything in your calendar appears here automatically — including meetings you add or move later." |
*
* @param {Agenda_Source_Mirror_BodyInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const agenda_source_mirror_body = /** @type {((inputs?: Agenda_Source_Mirror_BodyInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agenda_Source_Mirror_BodyInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("Alles wat in je agenda staat verschijnt hier automatisch — ook afspraken die je later toevoegt of verzet.")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Tout ce qui est dans votre agenda apparaît ici automatiquement — y compris les rendez-vous que vous ajoutez ou déplacez plus tard.")
	return /** @type {LocalizedString} */ ("Everything in your calendar appears here automatically — including meetings you add or move later.")
});